import React from "react"
import { useHistory } from "react-router-dom"
import styled from "styled-components"
import devices from "styles/devices"
import { Button, ButtonType } from "components/atoms/Button"
import { Card } from "components/atoms/Card"
import Typography from "components/_blueprint/Typography/Typography"
import RateCheckPhoneImage from "url:assets/images/phone-rate-check-notification.svg"

interface RateCheckPromiseCardProps {
  friendlyId: string
}

const RateCheckContainer = styled.div`
  background: linear-gradient(135deg, #f8faff 0%, #e8f1ff 100%);
  border-radius: 16px;
  padding: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;

  @media screen and ${devices.bp_sm} {
    flex-direction: row;
  }
`

const RateCheckContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const RateCheckIllustration = styled.div`
  position: relative;
  flex-shrink: 0;
  align-self: center;

  @media screen and ${devices.bp_sm} {
    align-self: auto;
  }
`

const PhoneImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`

const CardStyleOverrides = {
  borderRadius: "24px",
}

export const RateCheckPromiseCard: React.FC<RateCheckPromiseCardProps> = ({ friendlyId }) => {
  const history = useHistory()

  return (
    <Card
      theme="default"
      style={CardStyleOverrides}
      content={
        <RateCheckContainer>
          <RateCheckIllustration>
            <PhoneImage src={RateCheckPhoneImage} alt="Phone showing rate check notification" />
          </RateCheckIllustration>

          <RateCheckContent>
            <Typography.H4 margin="0 0 8px 0">Our Rate Check Promise</Typography.H4>
            <Typography.Body color="secondary" margin="0 0 16px 0">
              After your offer is accepted, we continue to check for a better rate on your deal. If
              one becomes available before you complete, we'll help you switch.
            </Typography.Body>
            <Button
              type={ButtonType.Outline}
              text="Learn more"
              onClick={() => {
                history.push(`/application/${friendlyId}/rate-check-promise`)
              }}
            />
          </RateCheckContent>
        </RateCheckContainer>
      }
    />
  )
}
